import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/Header/boxLogoWhite.png";
import HomeWhite from "../assets/home.png";
import HomeBlack from "../assets/home-1.png";
import FriendsWhite from "../assets/friends.png";
import FriendsBlack from "../assets/friends-1.png";
import ProfileWhite from "../assets/profile.png";
import ProfileBlack from "../assets/profile-1.png";
import PodcastWhite from "../assets/podcast.png";
import PodcastBlack from "../assets/podcast-1.png";
import SleepWhite from "../assets/sleep.png";
import SleepBlack from "../assets/sleep-1.png";
import NotificationImage from "../assets/notification.png";
import VideoWhiteImage from "../assets/video.png";
import VideoBlackImage from "../assets/video-1.png";
import logoutImage from "../assets/logout.png";
import PsychologistWhiteImage from "../assets/Psychologist/psychologist_white.png";
import PsychologistBlackImage from "../assets/Psychologist/psychologist_black.png";
import appStore from "../assets/PopUp/app-store.png";
import playStore from "../assets/PopUp/play-store.png";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const checkUserData = () => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    setIsLoggedIn(!!userData);
  };

  useEffect(() => {
    checkUserData();
  }, []);

  return (
    <div className="flex w-full justify-start items-center h-[100px] bg-[#3dc2cd] flex-row">
      {/* Logo + Store Buttons */}
      <div className="flex w-[30%] items-center p-5 space-x-4">
        <img
          src={logo}
          alt="logo"
          className="w-[120px] h-[100px] object-contain"
        />
        <div className="flex space-x-3 ml-2">
          <a
            href="https://apps.apple.com/us/app/goodpeople-call/id6740238582"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={appStore}
              alt="App Store"
              className="h-10 md:h-14 hover:scale-110 transition-transform"
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.emotalk"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={playStore}
              alt="Google Play"
              className="h-10 md:h-14 hover:scale-110 transition-transform"
            />
          </a>
        </div>
      </div>

      {/* Tabs */}
      <div className="flex flex-row w-[70%] justify-center h-full items-center">
        <div className="flex flex-col justify-center items-center h-full cursor-pointer mx-5" onClick={() => navigate("/")}>
          <img src={currentPath === "/" ? HomeBlack : HomeWhite} alt="Home" className="w-[30px] h-[30px] mb-[10px] object-contain" />
          <h4 className="m-0">Home</h4>
        </div>

        {/* <div className="flex flex-col justify-center items-center h-full cursor-pointer mx-5" onClick={() => navigate("/vision")}>
          <img src={currentPath === "/vision" ? VideoBlackImage : VideoWhiteImage} alt="Video" className="w-[30px] h-[30px] mb-[10px] object-contain" />
          <h4 className="m-0">Video</h4>
        </div> */}

        <div className="flex flex-col justify-center items-center h-full cursor-pointer mx-5" onClick={() => navigate("/friends")}>
          <img src={currentPath === "/friends" ? FriendsBlack : FriendsWhite} alt="Friends" className="w-[30px] h-[30px] mb-[10px] object-contain" />
          <h4 className="m-0">Friends</h4>
        </div>
        
        <div className="flex flex-col justify-center items-center h-full cursor-pointer mx-5" onClick={() => navigate("/podcastroom")}>
          <img src={currentPath === "/podcastroom" ? PodcastBlack : PodcastWhite} alt="Psychologist" className="w-[30px] h-[30px] mb-[10px] object-contain" />
          <h4 className="m-0">Podcast</h4>
        </div>

        <div className="flex flex-col justify-center items-center h-full cursor-pointer mx-5" onClick={() => navigate("/sleeproom")}>
          <img src={currentPath === "/sleeproom" ? SleepBlack : SleepWhite} alt="Psychologist" className="w-[30px] h-[30px] mb-[10px] object-contain" />
          <h4 className="m-0">Sleep</h4>
        </div>

        <div className="flex flex-col justify-center items-center h-full cursor-pointer mx-5" onClick={() => navigate("/audioroom")}>
          <img src={currentPath === "/audioroom" ? PsychologistBlackImage : PsychologistWhiteImage} alt="Psychologist" className="w-[30px] h-[30px] mb-[10px] object-contain" />
          <h4 className="m-0">Psychologist</h4>
        </div>

        <div className="flex flex-col justify-center items-center h-full cursor-pointer mx-5" onClick={() => navigate("/profile")}>
          <img src={currentPath === "/profile" ? ProfileBlack : ProfileWhite} alt="Profile" className="w-[30px] h-[30px] mb-[10px] object-contain" />
          <h4 className="m-0">Profile</h4>
        </div>

        {/* Notification */}
        <div className="flex w-[30%] justify-end items-center cursor-pointer" onClick={() => navigate("/friendzone")}>
          <img src={NotificationImage} alt="notification" className="w-[40px] h-[40px] object-contain" />
        </div>

        {/* Auth Buttons */}
        {isLoggedIn ? (
          <div className="flex flex-col justify-end items-center bg-[#3dc2cd] w-[10%] cursor-pointer" onClick={() => {
            if (window.confirm("Are you sure you want to logout?")) {
              localStorage.removeItem("userData");
              navigate("/login");
            }
          }}>
            <img src={logoutImage} className="w-[30px] h-[30px] object-contain" alt="logout" />
            <h3 className="text-[15px] text-black mt-[5px] m-0">Logout</h3>
          </div>
        ) : (
          <button
            className="bg-white h-[40px] flex justify-center items-center rounded-[10px] w-[10%]"
            onClick={() => navigate("/login")}
          >
            <h4 className="text-black px-5 m-0">SignUp</h4>
          </button>
        )}
      </div>
    </div>
  );
};

export default Header;
